import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=52643bc2&lang=pug"
import script from "./shop.vue?vue&type=script&lang=ts"
export * from "./shop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EcSpreadshirtShop: require('/home/runner/work/EC-Website/EC-Website/components/ecSpreadshirtShop.vue').default,VContainer: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VContainer.js').default})
